export default {
    delete_dashboard_title: "Delete Dashboard",
    delete_dashboard_descripcion: "Are you sure you want to delete this Dashboard?",
    delete_dashboard_success_message: "The dashboard has been deleted",
}